import React, { useEffect, useState } from "react";
import { NavBar, SearchBar } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { AssetsListener, AssetsListenerRemove } from "../assets/AssetsManager";
import { CellAssetsView, CellStateView } from "../factory/CellViews";
import { isLogin } from "../../NetworkFactory";

const SearchAccountController = ({goback, loginpush, data}) => {
    const type = data.type || '1';
    const [value, setValue] = useState('')
    const [searchedData, setSearchedData] = useState([])
    const [dataSource, setDataSource] = useState([])

    const searchValue = (val) => {
        setValue(val)
        if(val.length === 0) {
            setSearchedData([])
        } else {
            const filteredItems = dataSource.filter((item) => {
                    const symbol = item.symbol
                    if(typeof symbol === 'string') {
                        return item.symbol.toLowerCase().includes(val.toLowerCase())
                    }
                    return false
                }
            );
            setSearchedData(filteredItems)
        }
    };

    useEffect(() => {
        if(isLogin()) {
            AssetsListener(type, 'SearchAccountController', ({data = []}) => {
                setDataSource(data)
            })
            return () => {
                AssetsListenerRemove(type, 'SearchAccountController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <SearchBar value={value} onChange={val => {searchValue(val)}} clearable placeholder="Search balance"/>
                </NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    {
                        searchedData.length <=0 ? <CellStateView stateType={4}/> :  ''
                    }
                    {
                        searchedData.map((item, index) => (
                            <CellAssetsView onClick={()=>{loginpush('/assets/account', false, {data : item, type : type})}} key={index} item={item}/>
                        ))
                    }
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(SearchAccountController)